var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "forward-chatbot-tunings" }, [
    _c(
      "div",
      { staticClass: "settings" },
      [
        _c("div", { staticClass: "setting-section" }, [
          _c("div", { staticClass: "section-title" }, [
            _vm._v(_vm._s(_vm.$t("auto.selectChatbotToForward"))),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "setting-row" }, [
            _c(
              "div",
              { staticClass: "setting-group" },
              [
                _c("div", { staticClass: "label" }, [
                  _vm._v(_vm._s(_vm.$t("auto.chatbotScenario"))),
                ]),
                _vm._v(" "),
                _c("CustomPicker", {
                  attrs: {
                    items: _vm.stories,
                    idKey: "_id",
                    labelKey: "title",
                    title: _vm.$t("auto.selectScenario"),
                    icon: "smart_toy",
                  },
                  model: {
                    value: _vm.config.storyId,
                    callback: function ($$v) {
                      _vm.$set(_vm.config, "storyId", $$v)
                    },
                    expression: "config.storyId",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _vm.config.storyId && !_vm.config.runAIFirstForce
              ? _c(
                  "div",
                  { staticClass: "setting-group" },
                  [
                    _c("div", { staticClass: "label" }, [
                      _vm._v(_vm._s(_vm.$t("auto.startingBlock"))),
                    ]),
                    _vm._v(" "),
                    _c("CustomPicker", {
                      attrs: {
                        items: _vm.blocks,
                        idKey: "id",
                        labelKey: "name",
                        title: "Blok seçin",
                        icon: "account_tree",
                      },
                      model: {
                        value: _vm.config.initialBlockId,
                        callback: function ($$v) {
                          _vm.$set(_vm.config, "initialBlockId", $$v)
                        },
                        expression: "config.initialBlockId",
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ]),
        ]),
        _vm._v(" "),
        _c("a-divider"),
        _vm._v(" "),
        _c("div", { staticClass: "settings-row" }, [
          _c("div", { staticClass: "setting-section" }, [
            _c("div", { staticClass: "section-title" }, [
              _vm._v(_vm._s(_vm.$t("auto.aiSettings"))),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "setting-group" }, [
              _c(
                "div",
                { staticClass: "switch-row" },
                [
                  _c("div", { staticClass: "label" }, [
                    _vm._v(_vm._s(_vm.$t("auto.runAiFirst"))),
                  ]),
                  _vm._v(" "),
                  _c("a-switch", {
                    model: {
                      value: _vm.config.runAIFirstForce,
                      callback: function ($$v) {
                        _vm.$set(_vm.config, "runAIFirstForce", $$v)
                      },
                      expression: "config.runAIFirstForce",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "description" }, [
                _vm._v(
                  "\n                        " +
                    _vm._s(_vm.$t("auto.aiWillRespondFirstAfterForwarding")) +
                    "\n                    "
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "setting-group" }, [
              _c(
                "div",
                { staticClass: "switch-row" },
                [
                  _c("div", { staticClass: "label" }, [
                    _vm._v(_vm._s(_vm.$t("auto.forwardAllMessageHistory"))),
                  ]),
                  _vm._v(" "),
                  _c("a-switch", {
                    model: {
                      value: _vm.config.forwardAllMessagesToAI,
                      callback: function ($$v) {
                        _vm.$set(_vm.config, "forwardAllMessagesToAI", $$v)
                      },
                      expression: "config.forwardAllMessagesToAI",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "description" }, [
                _vm._v(
                  "\n                        " +
                    _vm._s(
                      _vm.$t("auto.allPreviousMessagesWillBeForwardedToAi")
                    ) +
                    "\n                    "
                ),
              ]),
            ]),
            _vm._v(" "),
            _vm.config.runAIFirstForce
              ? _c(
                  "div",
                  { staticClass: "setting-group" },
                  [
                    _c("div", { staticClass: "label" }, [
                      _vm._v(_vm._s(_vm.$t("auto.aiTriggerMessage"))),
                    ]),
                    _vm._v(" "),
                    _c("a-textarea", {
                      attrs: {
                        placeholder: _vm.$t("auto.firstMessageToSendToAi"),
                        "auto-size": { minRows: 2, maxRows: 4 },
                      },
                      model: {
                        value: _vm.config.aiTriggerMessage,
                        callback: function ($$v) {
                          _vm.$set(_vm.config, "aiTriggerMessage", $$v)
                        },
                        expression: "config.aiTriggerMessage",
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "setting-section" }, [
            _c("div", { staticClass: "section-title" }, [
              _vm._v(_vm._s(_vm.$t("auto.generalForwardingSettings"))),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "setting-group" }, [
              _c(
                "div",
                { staticClass: "switch-row" },
                [
                  _c("div", { staticClass: "label" }, [
                    _vm._v(_vm._s(_vm.$t("auto.boomerangMode"))),
                  ]),
                  _vm._v(" "),
                  _c("a-switch", {
                    model: {
                      value: _vm.config.boomerangMode,
                      callback: function ($$v) {
                        _vm.$set(_vm.config, "boomerangMode", $$v)
                      },
                      expression: "config.boomerangMode",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "description" }, [
                _vm._v(
                  "\n                        " +
                    _vm._s(
                      _vm.$t("auto.willBeForwardedBackWhenChatbotCompletes")
                    ) +
                    "\n                    "
                ),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "setting-group" },
              [
                _c("div", { staticClass: "label" }, [
                  _vm._v(_vm._s(_vm.$t("auto.chatbotTriggerStartMessage"))),
                ]),
                _vm._v(" "),
                _c("a-textarea", {
                  attrs: {
                    placeholder: _vm.$t("auto.chatbotTriggerStartMessage"),
                    "auto-size": { minRows: 2, maxRows: 4 },
                  },
                  model: {
                    value: _vm.config.chatbotTriggerMessage,
                    callback: function ($$v) {
                      _vm.$set(_vm.config, "chatbotTriggerMessage", $$v)
                    },
                    expression: "config.chatbotTriggerMessage",
                  },
                }),
              ],
              1
            ),
          ]),
        ]),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "actions" },
      [
        _c(
          "a-button",
          {
            on: {
              click: function ($event) {
                return _vm.$emit("cancel")
              },
            },
          },
          [_vm._v(_vm._s(_vm.$t("auto.cancel")))]
        ),
        _vm._v(" "),
        _c(
          "a-button",
          {
            attrs: { type: "primary", disabled: !_vm.isValid },
            on: { click: _vm.handleSend },
          },
          [_vm._v(_vm._s(_vm.$t("auto.forward")))]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }